import React, { useEffect } from "react";
// import logo from './logo.svg';
import "./App.css";
import AppRoutes from "./screens/AppRoutes";
import { createTheme, ThemeProvider } from "@mui/material";

// For the plugin to work kindly add a file .env.production
//  .env.production
//   > INLINE_RUNTIME_CHUNK=false ( Content of the file)
import { I18nextProvider } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import i18n from "i18next";
import enTranslations from "./locales/en/translation.json";
import hiTranslations from "./locales/hi/translation.json";
import guTranslations from "./locales/gu/translation.json";
import paTranslation from "./locales/pa/translation.json";
import mrTranslation from "./locales/mr/translation.json";
import taTranslation from "./locales/ta/translation.json";
import knTranslation from "./locales/kn/translation.json";
import orTranslation from "./locales/or/translation.json";
import AlertProvider from "./components/Alert";
import { setUserMessagingToken } from "./api/native";
import { isLoggedIn } from "./globals/utils";
import "react-datepicker/dist/react-datepicker.css";

i18n.use(LanguageDetector).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    hi: {
      translation: hiTranslations, //Hindi Translation
    },
    gu: {
      translation: guTranslations, // Gujarati translations
    },
    pa: {
      translation: paTranslation, //punjabi translation
    },
    mr: {
      translation: mrTranslation, //Marathi translations
    },
    ta: {
      translation: taTranslation, //Tamil translations
    },
    kn: {
      translation: knTranslation, //Kannada translations
    },
    or: {
      translation: orTranslation, //Oriya translations
    },
  },
  lng: localStorage.getItem("i18nextLng") || "en",
  fallbackLng: "en", // Default language
  debug: true, // Enable debug mode
  interpolation: {
    escapeValue: false, // React already safely escapes interpolated values
  },
});

const App = () => {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#4CAF50",
      },
      secondary: {
        main: "#795548",
      },
    },
    typography: {
      fontFamily: "Poppins, Arial, sans-serif",
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
  });

  useEffect(() => {
    if (isLoggedIn()) {
      window.addEventListener("message", function (data) {
        if (data.data["expoPushToken"]) {
          setUserMessagingToken(data.data["expoPushToken"]);
        }
      });
    }
  }, []);
  const isLandingPage = window.location.pathname.includes("/landing");
  return (
    <ThemeProvider theme={theme}>
      <AlertProvider>
        <I18nextProvider i18n={i18n}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: isLandingPage ? "0" : "0 0 4rem 0",
            }}
          >
            <div style={{ flex: 1 }}>
              <AppRoutes />
            </div>
          </div>
        </I18nextProvider>
      </AlertProvider>
    </ThemeProvider>
  );
};

export default App;
